/* eslint-disable import/no-anonymous-default-export */
import { post } from 'jquery';
import * as types from './feed.actionTypes';

const initState = {
  feed: [],
  page: 1,
  lastPage: 1,
  total: 0,
  isFetchingFeed: false,
  userId: null, //current feeds user id
  currentPost: null,
  statistics: {},
  statisticsView: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case types.FETCH_FEED_REQUEST:
      return {
        ...state,
        isFetchingFeed: true,
        statisticsView: false,
      };
    case types.FETCH_FEED_SUCCESS:
      return {
        ...state,
        feed: action.feed.meta.current_page === 1 ? action.feed.data : [...state.feed, ...action.feed.data],
        page: action.feed.meta.current_page,
        lastPage: action.feed.meta.last_page,
        total: action.feed.meta.total,
        isFetchingFeed: false,
      };
    case types.FETCH_FEED_FAILURE:
      return {
        ...state,
        isFetchingFeed: false,
      };

    case types.FETCH_FEED_STATISTICS:
      return {
        ...state,
        isFetchingFeed: true,
      };

    case types.FETCH_FEED_POST_STATISTICS:
      return {
        ...state,
        isFetchingFeed: true,
      };

    case types.FETCH_FEED_POST_STATISTICS_SUCCESS:
      return {
        ...state,
        statistics: action.statistics,
        isFetchingFeed: false,
        statisticsView: true,
      };

    case types.FETCH_FEED_STATISTICS_SUCCESS:
      return {
        ...state,
        statistics: action.statistics,
        isFetchingFeed: false,
        statisticsView: true,
      };

    case types.FETCH_FEED_POST_STATISTICS_FAILURE:
      return {
        ...state,
        isFetchingFeed: false,
      };

    case types.FETCH_FEED_STATISTICS_FAILURE:
      return {
        ...state,
        isFetchingFeed: false,
      };

    case types.SET_FEED_USER_ID:
      return {
        ...state,
        userId: action.uid,
      };

    case types.LIKE_TOGGLE:
      return {
        ...state,
        feed: state.feed.map(el =>
          el.id === action.id
            ? { ...el, liked: !el.liked, likes_count: el.liked ? el.likes_count - 1 : el.likes_count + 1 }
            : el
        ),
        currentPost:
          state.currentPost && state.currentPost.id === action.id
            ? { ...state.currentPost, liked: !state.currentPost.liked, likes_count: state.currentPost.liked ? state.currentPost.likes_count - 1 : state.currentPost.likes_count + 1 }
            : state.currentPost,
      };
    case types.COMMENT_LIKE_TOGGLE:
      const currentPostLikeToggle = state.currentPost ? {
        ...state?.currentPost,
        comments: state?.currentPost?.comments?.map(comm =>
          comm.id === action.id
            ? { ...comm, liked: !comm.liked, likes_count: comm.liked ? comm.likes_count - 1 : comm.likes_count + 1 }
            : comm
        ),
      } : null;

      return {
        ...state,
        feed: state.feed.map(el =>
          el.id
            ? {
              ...el,
              comments: el.comments
                && el.comments.map(comm =>
                  comm.id === action.id

                    ? { ...comm, liked: !comm.liked, likes_count: comm.liked ? comm.likes_count - 1 : comm.likes_count + 1 }
                    : comm
                ),
            }
            : el
        ),
        currentPost: currentPostLikeToggle
      };
    case types.REPLY_LIKE_TOGGLE:
      if (action.forFeed) {
        return {
          ...state,
          feed: state.feed.map(el =>
            el.id
              ? {
                ...el,
                comments: el.comments
                  && el.comments.map(comm =>
                    comm.id ? {
                      ...comm,

                      replies: comm.replies?.map(rep =>
                        rep.id === action.id

                          ? { ...rep, liked: !rep.liked, likes_count: rep.liked ? rep.likes_count - 1 : rep.likes_count + 1 }
                          : rep
                      ),
                    } : comm
                  ),

              }
              : el
          )
        }
      }
      const currentComment = state.currentPost.comments.find(cm => cm.id === action.commentId);
      const currentCommentInd = state.currentPost.comments.indexOf(currentComment);
      const currentReply = currentComment.replies.find(r => r.id === action.id);
      const replayInd = currentComment.replies.indexOf(currentReply);
      let mutatedReply = { ...currentReply };
      mutatedReply.likes_count = mutatedReply.liked ? mutatedReply.likes_count - 1 : mutatedReply.likes_count + 1;
      mutatedReply.liked = !currentReply.liked;
      let newComment = { ...currentComment };
      newComment.replies[replayInd] = mutatedReply;
      let comments = state.currentPost.comments.splice(currentCommentInd, 1, newComment);
      return {
        ...state,
        currentPost: {
          ...state.currentPost,
          comments
        }
      };

    case types.BOOKMARK_TOGGLE:
      return {
        ...state,
        feed: state.feed.map(el => (el.id === action.id ? { ...el, bookmarked: !el.bookmarked } : el)),
        currentPost:
          state.currentPost && state.currentPost.id === action.id
            ? { ...state.currentPost, bookmarked: !state.currentPost.bookmarked }
            : state.currentPost,
      };

    case types.FETCH_COMMENTS_SUCCESS:
      return {
        ...state,
        feed: state.feed.map(el =>
          el.id === action.id
            ? {
              ...el,
              comments: el.comments ? [...action.data.data.reverse(), ...el.comments] : action.data.data.reverse(),
              commentsTotal: action.data.meta.total,
            }
            : el
        ),
        currentPost:
          state.currentPost && state.currentPost.id === action.id
            ? {
              ...state.currentPost,
              comments: state.currentPost.comments
                ? [...action.data.data.reverse(), ...state.currentPost.comments]
                : action.data.data.reverse(),
              commentsTotal: action.data.meta.total,
            }
            : state.currentPost,
      };

    case types.COMMENT_ON_POST_SUCCESS:
      return {
        ...state,
        feed: state.feed.map(el =>
          el.id === action.id
            ? {
              ...el,
              comments: el.comments ? [...el.comments, action.comment] : [action.comment],
              comments_count: el.comments_count ? el.comments_count + 1 : 1,
            }
            : el
        ),
        currentPost:
          state.currentPost && state.currentPost.id === action.id
            ? {
              ...state.currentPost,
              comments: state.currentPost.comments
                ? [...state.currentPost.comments, action.comment]
                : [action.comment],
              comments_count: state.currentPost.comments_count ? state.currentPost.comments_count + 1 : 1,
              commentsTotal: state.currentPost.commentsTotal ? state.currentPost.commentsTotal + 1 : 1,
            }
            : state.currentPost,
      };

    case types.REPPLY_ON_COMMENT_SUCCESS:
      const currentPost = state.currentPost ? {
        ...state.currentPost,
        comments: state.currentPost.comments.map(comment => {
          if (comment.id === action.id) {
            if (!comment.replies) { comment.replies = []; }
            comment.replies.push(action.comment);
          }
          return comment;
        }),
        comments_count: state.currentPost.comments_count + 1
      } : null;
      return {
        ...state,
        feed: state.feed.map(el =>
          el.id === action.postId
            ? {
              ...el,
              comments_count: el.comments_count ? el.comments_count + 1 : 1,
              comments: el.comments.map(comm =>
                comm.id === action.id
                  ? { ...comm, replies: comm.replies ? [...comm.replies, action.comment] : [action.comment] }
                  : comm
              ),
            }
            : el
        ),
        currentPost
      };

    case types.FETCH_POST_SUCCESS:
      console.log('mm', action);
      if (action.post.media_status === "completed" || action.post.media_status === "failed") {
        return {
          ...state,
          feed: state.feed.map(el => el.id === action.post.id ?
            { ...el, media_status: "completed", files: action.post.files} :
            el
          ),
          currentPost: action.post
        }
      }

      return {
        ...state,
        currentPost: action.post
      };

    case types.DELETE_POST:
      return {
        ...state,
        feed: state.feed.filter(el => el.id !== action.id),
      };

    case types.PIN_POST_REQUEST:
      return {
        ...state,
        isFetchingFeed: true,
      };

    case types.PIN_POST_SUCCESS:
      return {
        ...state,
        isFetchingFeed: false,
      };

    case types.PURCHASE_POST_SUCCESS:
      return {
        ...state,
        feed: state.feed.map(el =>
          el.id === action.post.id
            ? {
              ...el,
              ...action.post,
            }
            : el
        ),
      };

    case types.CLEAR_FEED:
      return initState;
    default:
      return state;
  }
};
